import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicTitle from '../BasicTitle';
import HorizontalLoader from '../HorizontalLoader';

const Accordion = ({
  label,
  isOpen = false,
  isLoading = false,
  unstyled = false,
  footerBlocks,
  className,
  contentClassName,
  children,
}) => {
  return (
    <details
      className={classNames(
        'accordion',
        className,
        {
          ['accordion--unstyled']: unstyled
        }
      )}
      open={isOpen}
    >
      <summary>
        <BasicTitle uppercase={!unstyled} text={label} />
        <svg width={16} height={16} aria-hidden="true" focusable="false" className="accordion__icon" role="img" viewBox="0 0 448 512">
          <path fill="currentColor"
                d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
        </svg>
      </summary>
      <div className={classNames('accordion__content', contentClassName)}>
        {isLoading ? (
          <HorizontalLoader />
        ) : (
          <>{children}</>
        )}
      </div>
      {footerBlocks && (
        <div className={'accordion__footer'}>
          {footerBlocks.map((block, index) => block && (
            <div key={index} className={'accordion__footer-block'}>
              {block}
            </div>
          ))}
        </div>
      )}
    </details>
  );
}

Accordion.propTypes = {
  label: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};

export default Accordion;
